import React, { useEffect, useRef, useState } from "react";
import { MisionVisionContainer, MisionVisionItem, IconContainer, ValueItem } from './MisionVision.style'
import Mision from '../../assets/MisionVision/Mision.png'
import Vision from '../../assets/MisionVision/Vision.png'
import Valores from '../../assets/MisionVision/Valores.png'
import { FaCheck } from 'react-icons/fa'

const useIntersectionObserver = (options) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIsVisible(entry.isIntersecting);
    }, options);

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [options]);

  return [ref, isVisible];
};

const MisionVision = () => {
    const [misionRef, isMisionVisible] = useIntersectionObserver({ threshold: 0.2 });
    const [visionRef, isVisionVisible] = useIntersectionObserver({ threshold: 0.2 });
    const [valoresRef, isValoresVisible] = useIntersectionObserver({ threshold: 0.2 });

    return(
        <MisionVisionContainer>
            <MisionVisionItem ref={misionRef} style={{
                opacity: isMisionVisible ? 1 : 0,
                transform: isMisionVisible ? "translateY(0)" : "translateY(50px)",
                transition: "opacity 0.8s ease-out, transform 0.8s ease-out"
            }}>
                <IconContainer>
                    <img src={Mision} />
                </IconContainer>
                <h2>Misión</h2>
                <p>Contribuimos a la enseñanza, divulgación, reconocimiento y práctica profesional de la Medicina Integrativa brindando más posibilidades terapéuticas para el beneficio de los pacientes.</p>
            </MisionVisionItem>
            <MisionVisionItem ref={visionRef} style={{
                opacity: isVisionVisible ? 1 : 0,
                transform: isVisionVisible ? "translateY(0)" : "translateY(50px)",
                transition: "opacity 0.8s ease-out, transform 0.8s ease-out"
            }}>
                <IconContainer>
                    <img src={Vision} />
                </IconContainer>
                <h2>Visión</h2>
                <p>Somos la empresa líder en América Central en la comercialización de aparatología médica, agentes terapéuticos e insumos médicos en el campo de la Medicina Integrativa.</p>
            </MisionVisionItem>
            <MisionVisionItem ref={valoresRef} style={{
                opacity: isValoresVisible ? 1 : 0,
                transform: isValoresVisible ? "translateY(0)" : "translateY(50px)",
                transition: "opacity 0.8s ease-out, transform 0.8s ease-out"
            }}>
                <IconContainer>
                    <img src={Valores} />
                </IconContainer>
                <h2>Valores</h2>
                <ValueItem style={{
                    opacity: isValoresVisible ? 1 : 0,
                    transform: isValoresVisible ? "translateX(0)" : "translateX(-20px)",
                    transition: "opacity 0.8s ease-out, transform 0.8s ease-out",
                    transitionDelay: "0.1s"
                }}>
                    <FaCheck />
                    <p>Excelencia</p>
                </ValueItem>
                <ValueItem style={{
                    opacity: isValoresVisible ? 1 : 0,
                    transform: isValoresVisible ? "translateX(0)" : "translateX(-20px)",
                    transition: "opacity 0.8s ease-out, transform 0.8s ease-out",
                    transitionDelay: "0.2s"
                }}>
                    <FaCheck />
                    <p>Innovación</p>
                </ValueItem>
                <ValueItem style={{
                    opacity: isValoresVisible ? 1 : 0,
                    transform: isValoresVisible ? "translateX(0)" : "translateX(-20px)",
                    transition: "opacity 0.8s ease-out, transform 0.8s ease-out",
                    transitionDelay: "0.3s"
                }}>
                    <FaCheck />
                    <p>Ética</p>
                </ValueItem>
                <ValueItem style={{
                    opacity: isValoresVisible ? 1 : 0,
                    transform: isValoresVisible ? "translateX(0)" : "translateX(-20px)",
                    transition: "opacity 0.8s ease-out, transform 0.8s ease-out",
                    transitionDelay: "0.4s"
                }}>
                    <FaCheck />
                    <p>Responsabilidad</p>
                </ValueItem>
                <ValueItem style={{
                    opacity: isValoresVisible ? 1 : 0,
                    transform: isValoresVisible ? "translateX(0)" : "translateX(-20px)",
                    transition: "opacity 0.8s ease-out, transform 0.8s ease-out",
                    transitionDelay: "0.5s"
                }}>
                    <FaCheck />
                    <p>Trabajo en Equipo</p>
                </ValueItem>
            </MisionVisionItem>
        </MisionVisionContainer>
    )
}

export default MisionVision
